import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'cars/contract';
const model = 'cars/contract';
const wizardName = 'RemoveExtension';
const wizardObject = 'Contract';
const wizardAction = 'removeExtension';

const RemoveExtension = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const [drawable, setDrawable] = useState(true);
    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const [dissociated, setDissociated] = useState([])

    const handleCheckChange = (event) => {
        const checked = event.target.checked;
        const value = event.target.value;

        setDissociated((prev) => {
            if (checked) {
                return prev.includes(value) ? prev : [...prev, value];
            } else {
                return prev.filter((v) => v !== value);
            }
        });
    };

    const detailConfig = {
        "tabs": [
            {
                "name": "removeExtension",
                "fieldsets": [
                    {
                        "name": "removeExtension",
                        "fields": {
                            "removeExtension": {
                                "type": "sectionmessageblock",
                                "title": "remove_extension_message_title",
                                "paragraph": "remove_extension_message_paragraph",
                                "icon": "faTrashCanXmark",
                                "className": "col-12 warning",
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(true)

    useEffect(() => {
        if (success) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success]);

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    values={{
                        "id": item?.data?._id
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    save={handleSave}
                    onEditing={setEditing}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t(wizardName)}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t(wizardName)}
                            subtitle={t('Remove this Contract Extension')}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default RemoveExtension;